import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialogComponent } from 'app/components/dialog/dialog';
import { Agenda } from 'app/model/agenda';
import { Agende } from 'app/model/agende';
import { IPaziente, IPlace } from 'app/model/paziente';
import { Paziente, Pazienti } from 'app/model/pazienti';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { RESTArray } from '../angular-rest';
import { NewPatientComponent } from './newPatient/newPatient';
import { SelezionePeriodoComponent } from './selezione-periodo/periodo';

@Component({
	selector: 'app-anagrafica',
	templateUrl: './anagrafica.html',
	styleUrls: ['./anagrafica.css']
})
export class AnagraficaComponent {

	private finalizers = new Subscription();
	private agenda: Agenda;

	filteredPatients: [Paziente, IPaziente][];
	page: [Paziente, IPaziente][];

	searchKeys = ['1.nome', '1.cognome', '1.codicefiscale']; // TODO: Configurare con pesi
	pending: Promise<any> = Promise.resolve(true);

	pazienti$: RESTArray<Paziente>;
	pazientiFlat$: Observable<[Paziente, IPaziente][]>;

	private set pazienti(value: RESTArray<Paziente>) {
		this.pazienti$ = value;

		this.pazientiFlat$ = value.pipe(
			catchError((error: HttpErrorResponse) => {
				// non un errore in questo caso! 
				if (error.status === 409) {
					return Observable.of();
				} else {
					return Observable.throw(error);
				}
			}
			),
			switchMap((paz$: Paziente[]) => {
				return (paz$.length ? Observable.combineLatest(...paz$) : Observable.from([[]]))
					.pipe(
						map(paz => paz.map((p, i) => [paz$[i], p] as [Paziente, IPaziente])),
				)
			})
		)
	}

	constructor(
		route: ActivatedRoute,
		agende: Agende,
		router: Router,
		private readonly modalService: NgbModal,
		private readonly pazientiTypeahead: Pazienti
	) {
		this.finalizers.add(Observable.combineLatest(route.parent.params, agende)
			.subscribe(([params, _agende]) => {
				this.agenda = _agende.find(a =>
					a.codice_fiscale === params.codice_fiscale &&
					a.nome === params.agenda
				);

				if (!this.agenda) {
					router.navigateByUrl('/agende');
				} else {
					this.pazienti = this.agenda.pazienti;
				}
			})
		);

	}

	async updatePatient(paziente$: Paziente, current: IPaziente, update: Partial<IPaziente>) {
		try {
			if ('codicefiscale' in update || 'nome' in update || 'cognome' in update) {
				const modalRef = this.modalService.open(AlertDialogComponent);
				modalRef.componentInstance.setMessage("Sei sicuro di voler modificare questo campo?");
				modalRef.componentInstance.setConfirm(true);
				modalRef.result.then((confirmed: boolean) => {
					if (confirmed) {
						// Che merda.
						paziente$.update({
							...current, ...update, ...{
								recapito: { ...current.recapito, ...update.recapito },
								residenza: { ...current.residenza, ...update.residenza }
							}
						});
					}
				}, () => { });
			} else {
				await paziente$.update({
					...current, ...update, ...{
						recapito: { ...current.recapito, ...update.recapito },
						residenza: { ...current.residenza, ...update.residenza }
					}
				});
			}
		} catch (e) {
			this.openAlertDialog(current, e);
		}
		this.pazientiTypeahead.refresh();
	}

	addPatient() {
		const modalRef = this.modalService.open(NewPatientComponent, {
			size: 'lg'
		});

		modalRef.result.then(
			async (patient: IPaziente) => {
				try {
					await this.pazienti$.add(Object.assign({},
						patient,
						patient.dataNascita ? {
							dataNascita: moment.utc({
								year: patient.dataNascita.year,
								month: patient.dataNascita.month - 1,
								date: patient.dataNascita.day
							}).format('DD/MM/YYYY')
						} : {}
					));
				} catch (e) {
					this.openAlertDialog(patient, e);
				}
				this.pazientiTypeahead.refresh();
			},
			() => { }
		);
	}

	openAlertDialog(patient: IPaziente, e: any) {
		if (e.status === 409) {
			const modalRef = this.modalService.open(AlertDialogComponent);
			modalRef.componentInstance.setMessage(`Il paziente ${patient.codicefiscale} esiste già`)
		} else {
			throw e;
		};
	}

	validPlace(value: IPlace) {
		return value &&
			value.indirizzo &&
			value.numciv &&
			value.citta;
	}

	patientTabChanged(paziente: IPaziente, $event: NgbTabChangeEvent) {
		paziente['selectedTab'] = $event.nextId;
	}

	print(paziente: IPaziente) {
		const modalRef = this.modalService.open(SelezionePeriodoComponent);

		modalRef.componentInstance.paziente = `${paziente.cognome} ${paziente.nome}`;
		modalRef.componentInstance.agenda = this.agenda;

		modalRef.result.then(
			() => { },
			() => { }
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/anagrafica/anagrafica.ts